var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWholesaleOrder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.12,70.85c-1.24-4.37-4.63-7.81-8.98-9.11l-16.84-5.03c-.2,1.05-.64,2.06-1.34,2.94l-.67,.85-.81,1.03-5.17,6.59c-1.33,1.69-3.57,2.36-5.6,1.68l-5.66-1.9v17.51c0,.97-.79,1.76-1.76,1.76h-5.95c-.97,0-1.76-.79-1.76-1.76v-17.51l3.38-1.14h0l-9.04,3.03c-2.03,.68-4.28,.01-5.6-1.68l-6.66-8.47c-.69-.88-1.14-1.9-1.34-2.95l-16.86,5.03c-4.36,1.3-7.74,4.74-8.98,9.11l-8.48,29.95,15.8,5.3,.64,.22h0l3.21,1.07v8.28h0v46.14h77.29v-54.42l10.68-3.58h0l.98-.33,7.99-2.68-8.48-29.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "147.96 66.77 147.96 66.77 149.31 66.32 147.96 66.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.29,51.5h-30.87l.07,.13c.32,.61,.75,1.17,1.28,1.65l14.55,13.04h0l10.09-9.05,.46-.41,4-3.58c.43-.39,.8-.84,1.09-1.32l.25-.45h-.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.97,
    y: 161.81,
    width: 1.28,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.25,161.81H110.65v2.93c0,2.91,2.36,5.27,5.27,5.27h66.76c2.91,0,5.27-2.36,5.27-5.27v-2.93h-7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.45,106.32l-.64-.21h0l-15.8-5.3-.52,1.83c-.91,3.21,.86,6.56,4.02,7.62l12.3,4.13,3.85,1.29h0v-8.28l-3.21-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.63,
    y: 103.82,
    width: 0,
    height: 0,
    transform: "translate(-25.46 99.79) rotate(-26.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.6,
    y: 103.65,
    width: 1.03,
    height: 0,
    transform: "translate(-16.46 41.06) rotate(-11.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.12,102.64l-.52-1.83-7.99,2.68h0l-.98,.33h0l-10.68,3.58v8.28l10.25-3.44h0l5.89-1.98c3.16-1.06,4.93-4.41,4.02-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.91,42.65h-25.21c-1.4,0-2.76,.39-3.93,1.09v5.11c0,.93,.23,1.84,.63,2.65h31.79c.41-.82,.63-1.72,.63-2.66v-5.1h0c-1.17-.7-2.52-1.09-3.93-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.76,53.28c-.53-.47-.95-1.03-1.28-1.65h0s-.04-.09-.07-.13c-.41-.82-.63-1.72-.63-2.65h0v-5.11c-.88,.53-1.67,1.24-2.28,2.11l-2.07,2.9-1.96,2.75c-1.1,1.55-1.48,3.44-1.15,5.22,.2,1.05,.64,2.07,1.34,2.95l6.66,8.47c1.33,1.69,3.57,2.36,5.6,1.68l9.04-3.03,1.35-.45-14.55-13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.66,66.77l-1.35-.45h0l-1.35,.45-3.38,1.14v17.51c0,.97,.79,1.76,1.76,1.76h5.95c.97,0,1.76-.79,1.76-1.76v-17.51l-3.38-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.15,51.5l-1.96-2.75-2.07-2.9c-.62-.86-1.4-1.57-2.28-2.11h0v5.1c0,.93-.23,1.84-.63,2.66l-.25,.45c-.3,.49-.66,.93-1.09,1.32l-4,3.58-.46,.41-10.09,9.05,1.35,.45h0l3.38,1.14,5.66,1.9c2.03,.68,4.28,.01,5.6-1.68l5.17-6.59,.81-1.03,.67-.85c.69-.88,1.14-1.89,1.34-2.94,.34-1.78-.04-3.67-1.15-5.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.99,
    y: 65.83,
    width: 0,
    height: 1.43,
    transform: "translate(39.19 187.58) rotate(-71.45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.75,219.29h91.11c2.35,0,4.46-1.47,5.26-3.69l23.77-65.51c1.84-4.88-1.77-10.09-6.98-10.09H79.84l28.91,79.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.96,240.21H107.91c-5.78,0-10.46-4.68-10.46-10.46h0c0-5.78,4.68-10.46,10.46-10.46h92.14"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 128.39,
    cy: 251.31,
    r: 11.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 178.94,
    cy: 251.31,
    r: 11.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.91,219.29l-42.2-114.38c-.14-.39-.52-.65-.94-.65h-27.74"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 154.61,
    y1: 166.03,
    x2: 154.61,
    y2: 193.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.99,
    y1: 179.65,
    x2: 168.22,
    y2: 179.65
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.83,
    y: 100.27,
    width: 37.27,
    height: 10.23,
    rx: 5.12,
    ry: 5.12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.65,90.29l8.71-2.82c2.8-.91,5.85,.35,7.19,2.98l4.17,8.15c.57,1.12,1.49,2.04,2.61,2.61l8.15,4.17c2.62,1.34,3.89,4.39,2.98,7.19l-2.82,8.71c-.39,1.2-.39,2.49,0,3.7l2.82,8.71c.91,2.8-.35,5.85-2.98,7.19l-8.15,4.17c-1.12,.57-2.04,1.49-2.61,2.61l-4.17,8.15c-1.34,2.62-4.39,3.89-7.19,2.98l-8.71-2.82c-1.2-.39-2.49-.39-3.7,0l-8.71,2.82c-2.8,.91-5.85-.35-7.19-2.98l-4.17-8.15c-.57-1.12-1.49-2.04-2.61-2.61l-8.15-4.17c-2.62-1.34-3.89-4.39-2.98-7.19l2.82-8.71c.39-1.2,.39-2.49,0-3.7l-2.82-8.71c-.91-2.8,.35-5.85,2.98-7.19l8.15-4.17c1.12-.57,2.04-1.49,2.61-2.61l4.17-8.15c1.34-2.62,4.39-3.89,7.19-2.98l8.71,2.82c1.2,.39,2.49,.39,3.7,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 209.79,
    cy: 113.12,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 229.82,
    cy: 133.15,
    r: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 205.97,
    y1: 136.97,
    x2: 233.64,
    y2: 109.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleOrder2);
export default __webpack_public_path__ + "static/media/wholesale_order_2.5e4993af533b2b319c92e0a0d82f89d9.svg";
export { ForwardRef as ReactComponent };